import React, { useContext } from "react";
import { StyleSheet }        from "react-native";
import { Switch, Route }     from "react-router-dom";
import Row                   from "~/layouts/Row";
import Col                   from "~/layouts/Col";
import ConversationList      from "~/components/ConversationList/index.web";
import Screen                from "~/layouts/Screen/";
import SidePanel             from "../../components/SidePanel";
import ParticipantDetails    from "../../components/Participant/ParticipantDetails/index.web";
import ConversationHeader    from "../../components/Headers/ConversationHeader/index.web";
import ConversationScreen    from "../ConversationScreen/index.web";
import ComposeScreen         from "../ComposeScreen/index.web";
import SuggestedCustomersList from "../../components/SuggestedCustomersList/index.web";

export default function InboxScreen({ history, match }) {
  return (
    <Screen>
      <Row style={[styles.inner]}>
        <SidePanel />
        <Col>
          <ConversationHeader />
          <Row style={{ flex: 1 }}>
            <Col style={[styles.leftPanel]}>
              <ConversationList />
            </Col>
            <Col style={[styles.centerPanel]}>
              <Switch>
                <Route path="/messages/new" component={ComposeScreen} />
                <Route path="/messages/:id" component={ConversationScreen} />
                <Route path="/messages"></Route>
              </Switch>
            </Col>
            <Switch>
              <Route path="/messages/new">
                <Col style={[styles.contactPanel]}>
                  <SuggestedCustomersList />
                </Col>
              </Route>
              <Route path="/messages/:id">
                <Col style={[styles.participantPanel]}>
                  <ParticipantDetails />
                  <Route path="/messages"></Route>
                </Col>
              </Route>
            </Switch>
          </Row>
        </Col>
      </Row>
    </Screen>
  );
}

const styles = StyleSheet.create({
  conversation__container: {
    backgroundColor: "#fff",
    flex: 1,
  },
  leftPanel: {
    maxWidth: 320,
    borderRightWidth: 1,
    borderRightColor: "#eeeddd",
  },
  leftPanelCompact: {
    maxWidth: "100%",
    height: "100%",
    borderRightWidth: 1,
    borderRightColor: "#eeeddd",
  },
  centerPanel: {
    minWidth: 380,
  },
  participantPanel: {
    maxWidth: "25%",
    minWidth: 375,
    borderLeftWidth: 1,
    borderLeftColor: "#eeeddd",
  },
  contactPanel: {
    maxWidth: "18%",
    minWidth: 325,
    borderLeftWidth: 1,
    borderLeftColor: "#eeeddd",
  },
  inner: {
    flex: 1,
  },
});
